module.exports = __webpack_public_path__ + "static/r2c2-25fd9c880f9849103c883929972888c4.png";